<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8,7C8.55,7,9,6.55,9,6C9,5.45,8.55,5,8,5C7.45,5,7,5.45,7,6C7,6.55,7.45,7,8,7C8,7,8,7,8,7ZM4,11C4,11,5,11,5,11C5.55,11,6,10.55,6,10C6,10,6,8,6,8C6,7.45,5.55,7,5,7C5,7,4,7,4,7C3.45,7,3,7.45,3,8C3,8,3,10,3,10C3,10.55,3.45,11,4,11C4,11,4,11,4,11ZM11,5C11.55,5,12,4.55,12,4C12,4,12,3,12,3C12,2.45,11.55,2,11,2C10.45,2,10,2.45,10,3C10,3,10,4,10,4C10,4.55,10.45,5,11,5C11,5,11,5,11,5ZM15,2C15,2,14,2,14,2C13.45,2,13,2.45,13,3C13,3,13,10,13,10C13,10.55,13.45,11,14,11C14,11,15,11,15,11C15.55,11,16,10.55,16,10C16,10,16,3,16,3C16,2.45,15.55,2,15,2C15,2,15,2,15,2ZM15,12C15,12,2,12,2,12C2,12,2,3,2,3C2,2.45,1.55,2,1,2C0.45,2,0,2.45,0,3C0,3,0,13,0,13C0,13.55,0.45,14,1,14C1,14,15,14,15,14C15.55,14,16,13.55,16,13C16,12.45,15.55,12,15,12C15,12,15,12,15,12Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'WaterfallChart',
} as DefineComponent
</script>
